/** 기간 필터 입력 (from/to). 우측에 children 슬롯으로 검색박스/카운트 등 배치. */
export function DateRangeBar({
  from, to, onFrom, onTo, children,
}: {
  from: string; to: string
  onFrom: (v: string) => void; onTo: (v: string) => void
  children?: React.ReactNode
}) {
  return (
    <div className="sticky top-0 z-20 -mx-6 px-6 py-2 bg-slate-50/95 backdrop-blur border-b border-slate-200/60 mb-3">
      <div className="bg-white rounded-xl border border-slate-200 p-3 flex items-center gap-3 flex-wrap shadow-sm">
        <label className="text-xs font-semibold text-slate-500">기간</label>
        <input type="date" value={from} onChange={(e) => onFrom(e.target.value)}
               className={`px-2 py-1.5 border rounded-lg text-sm tabular-nums ${from ? 'border-slate-300' : 'border-amber-400 ring-1 ring-amber-200'}`}/>
        <span className="text-slate-400">~</span>
        <input type="date" value={to} onChange={(e) => onTo(e.target.value)}
               className={`px-2 py-1.5 border rounded-lg text-sm tabular-nums ${to ? 'border-slate-300' : 'border-amber-400 ring-1 ring-amber-200'}`}/>
        {(!from || !to) && (
          <span className="text-xs text-amber-600 font-medium whitespace-nowrap">← 기간을 지정하면 조회됩니다</span>
        )}
        {children}
      </div>
    </div>
  )
}
